(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-rfq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('ContactRfqForm');
    if (!form) return;
    var dataEl = form.querySelector('[data-rfq-data]');
    var catSel = form.querySelector('[data-rfq-cat]');
    var prodSel = form.querySelector('[data-rfq-prod]');
    var listEl = form.querySelector('[data-rfq-selected]');
    var hidden = form.querySelector('[data-rfq-hidden]');
    var count = form.querySelector('[data-rfq-count]');
    if (!dataEl || !catSel || !prodSel || !listEl || !hidden) return;

    var data = {};
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selected = [];

    function sync() {
      hidden.value = selected.join('; ');
      if (count) count.textContent = selected.length ? '(' + selected.length + ' selectate)' : '';
      listEl.innerHTML = '';
      selected.forEach(function (title, i) {
        var li = document.createElement('li');
        li.className = 'contact-rfq__chip';
        var span = document.createElement('span');
        span.textContent = title;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'contact-rfq__chip-remove';
        btn.setAttribute('aria-label', 'Elimină ' + title);
        btn.textContent = '×';
        btn.addEventListener('click', function () {
          selected.splice(i, 1);
          sync();
        });
        li.appendChild(span);
        li.appendChild(btn);
        listEl.appendChild(li);
      });
    }

    catSel.addEventListener('change', function () {
      var items = data[catSel.value] || [];
      prodSel.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Selectează produsul…';
      prodSel.appendChild(placeholder);
      items.forEach(function (title) {
        var option = document.createElement('option');
        option.value = title;
        option.textContent = title;
        prodSel.appendChild(option);
      });
      prodSel.disabled = items.length === 0;
    });

    prodSel.addEventListener('change', function () {
      var value = prodSel.value;
      if (value && selected.indexOf(value) === -1) selected.push(value);
      prodSel.value = '';
      sync();
    });

    form.addEventListener('submit', function () {
      hidden.value = selected.join('; ');
    });
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
